export const bodyParagraphs = [
  'Erlandson Trade säljer ädelträ, plywood, rostfria marina produkter samt förädlade teak- och mahognyprodukter för hem- och båtinredning.',
  'Lagret utanför Gimo i bruk, men begränsad bemanning. Säkrast på plats under sommarhalvåret och helger. Maila för mer information.',
  'Väldigt mycket teak och rostfritt på hyllan och en hel del mahogny och annat.',
  'Plywood, fanér och lister längre än 120 cm endast för avhämtning ifall inga större beställningar.',
]

export const headline =
  'Erlandson Trade säljer ädelträ, plywood, rostfria marina produkter samt förädlade teak- och mahognyprodukter för hem- och båtinredning.'
